import { z } from "zod";

// Create a reusable "Required Number" schema
export const zRequiredNumber = (errorMsg: string, typeErrorMsg: string) =>
  z.preprocess(
    (val) => (val === "" || val === null || val === undefined ? null : Number(val)),
    z
      .number({ message: typeErrorMsg })
      .nullable()
      .refine((val) => val !== null, { message: errorMsg }),
  );

// Create a reusable "Required String" schema
export const zRequiredString = (errorMsg: string) => z.string().min(1, errorMsg);

// Create a reusable "Required Email" schema
export const zRequiredEmail = (errorMsg: string, invalidEmailMsg: string) =>
  zRequiredString(errorMsg).email(invalidEmailMsg);
